import 'projects/sharedComponents/src/pet/shareModal/shareButton.scss';

import { Heap, HeapAction } from 'clientServerShared/types/eventTracking';

import { Button } from '@mui/material';
import { ShareButtonFragment } from 'projects/sharedComponents/src/generated/graphql-client-types';
import ShareIcon from '@mui/icons-material/Share';
import { ShareModal } from 'projects/sharedComponents/src/pet/shareModal/shareModal';
import clsx from 'clsx';
import { useToggle } from 'react-use';

type ShareButtonProps = {
  shareOptions: ShareButtonFragment;
  className?: string;
} & Heap;

export const ShareButton: React.FC<ShareButtonProps> = ({ shareOptions, className, heapMetadata }) => {
  const classes = clsx(className, 'shareButton-button');
  const [shareModalOpen, setShareModalOpen] = useToggle(false);

  return (
    <>
      <Button
        className={classes}
        variant="text"
        onClick={setShareModalOpen}
        data-heap-category={heapMetadata?.heapCategory}
        data-heap-action={heapMetadata?.heapAction ?? HeapAction.SHARE_RESULTS_MODAL}
      >
        <ShareIcon />
        SHARE
      </Button>
      <ShareModal
        open={shareModalOpen}
        onClose={setShareModalOpen}
        shareOptions={shareOptions}
        heapMetadata={heapMetadata}
      />
    </>
  );
};
